module.exports = __webpack_public_path__ + "static/img/img_p2_1_phone.9557e3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_p2_1_phone.png
// module id = WIQq
// module chunks = 1